import Reveal from '../../../shared/Reveal/Reveal';
import { useVpsHostingWhyClientsContent } from '../../../../hooks/useVpsHostingWhyClientsContent';
import clockIcon from '../../../../assets/images/vpshosting/whyclients/ClockCountdown.svg';
import desktopIcon from '../../../../assets/images/vpshosting/whyclients/DesktopTower.svg';
import broadcastIcon from '../../../../assets/images/vpshosting/whyclients/Broadcast.svg';
import lockIcon from '../../../../assets/images/vpshosting/whyclients/LockKey (1).svg';
import './WhyClients.css';

const fallbackIcons = [clockIcon, desktopIcon, broadcastIcon, lockIcon];

const WhyClients = () => {
  const { content, isLoading } = useVpsHostingWhyClientsContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, items } = content;

  return (
    <section className="vps-hosting-why-clients">
      <div className="vps-hosting-why-clients__inner">
        <Reveal>
          <h2 className="vps-hosting-why-clients__title">{title}</h2>
        </Reveal>

        <div className="vps-hosting-why-clients__grid">
          {items.map(({ title: itemTitle, text, icon }, index) => (
            <Reveal key={itemTitle} delay={index * 70}>
              <article className="vps-hosting-why-clients__item">
                <img
                  className="vps-hosting-why-clients__icon"
                  src={icon || fallbackIcons[index]}
                  alt=""
                  aria-hidden="true"
                />
                <h3 className="vps-hosting-why-clients__item-title">{itemTitle}</h3>
                <p className="vps-hosting-why-clients__item-text">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyClients;
